import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import {
  isDataExist,
  validateEditorData,
} from '../../editor/defaultOptions.js';

import Editor from '../../editor/editor.jsx';

const ChangeImpactStateReview = ({ changeImpact }) => {
  const currentStateEditorOptions = {
    holder: 'current-state-change-impact-editor',
    readOnly: true,
    minHeight: 0,
  };
  const futureStateEditorOptions = {
    holder: 'future-state-change-impact-editor',
    readOnly: true,
    minHeight: 0,
  };
  const actionPlanEditorOptions = {
    holder: 'action-plan-change-impact-editor',
    readOnly: true,
    minHeight: 0,
  };

  return (
    <div className="component component-bg-white">
      <Row>
        <Col xs={4}>
          <h3 className="flex text-muted m-b-12">Current State</h3>
          <div>
            {changeImpact.currentState &&
            isDataExist(validateEditorData(changeImpact.currentState)) ? (
              <Editor
                options={currentStateEditorOptions}
                data={validateEditorData(changeImpact.currentState)}
              />
            ) : (
              '—'
            )}
          </div>
        </Col>

        <Col xs={4}>
          <h3 className="flex text-muted m-b-12">Future State</h3>
          <div>
            {changeImpact.futureState &&
            isDataExist(validateEditorData(changeImpact.futureState)) ? (
              <Editor
                options={futureStateEditorOptions}
                data={validateEditorData(changeImpact.futureState)}
              />
            ) : (
              '—'
            )}
          </div>
        </Col>

        <Col xs={4}>
          <h3 className="flex text-muted m-b-12">Action Plan</h3>
          <div>
            {changeImpact.actionPlan &&
            isDataExist(validateEditorData(changeImpact.actionPlan)) ? (
              <Editor
                options={actionPlanEditorOptions}
                data={validateEditorData(changeImpact.actionPlan)}
              />
            ) : (
              '—'
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ChangeImpactStateReview;

ChangeImpactStateReview.propTypes = {
  changeImpact: PropTypes.shape({
    peopleImpacted: PropTypes.number,
  }).isRequired,
};
